import { useState, useMemo, useCallback } from "react";
import { UseAvatarProps } from "../types/avatar-types";
import React from "react";

export const useAvatar = ({
  src,
  name,
  alt,
  size,
  shape,
  style = {},
}: UseAvatarProps) => {
  const [imageError, setImageError] = useState(false);

  const sizes = useMemo(
    () => ({
      small: "32px",
      medium: "48px",
      large: "64px",
      xlarge: "96px",
    }),
    []
  );

  const getInitials = useCallback((nameToProcess?: string) => {
    if (!nameToProcess) return "?";
    return nameToProcess
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  }, []);

  const avatarStyle: React.CSSProperties = useMemo(
    () => ({
      width: sizes[size],
      height: sizes[size],
      borderRadius: shape === "circle" ? "50%" : "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize:
        size === "small"
          ? "14px"
          : size === "large"
          ? "24px"
          : size === "xlarge"
          ? "32px"
          : "18px",
      fontWeight: "600",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      overflow: "hidden",
      ...style,
    }),
    [size, shape, style, sizes]
  );

  const handleError = useCallback(() => {
    setImageError(true);
  }, []);

  const shouldShowImage = src && !imageError;
  const initials = getInitials(name || alt);

  return {
    imageError,
    avatarStyle,
    handleError,
    shouldShowImage,
    initials,
  };
};
